// The Vortex Scout as a line icon, traced from the product photo: the
// landscape body with its chamfered bumper corners, the main screen, the side
// panel (small screen, two keys, D-pad) and the antenna above it. Drawn on a
// 48 grid so the side panel stays sharp at tile size; strokes use currentColor.

import type { SVGProps } from 'react';

export function ScoutIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <rect x="39" y="4.5" width="3" height="9.5" rx="1.5" />
      <path d="M5.5 14h37l3 3v23l-3 3h-37l-3-3V17z" />
      <rect x="6.5" y="18" width="28" height="21" rx="1.5" />
      <rect x="38" y="18" width="5" height="7" rx="1" />
      <path d="M38.5 28.5h4M38.5 31.5h4" />
      <path d="M40.5 34.25v4.5M38.25 36.5h4.5" />
    </svg>
  );
}
